import _ from '@lodash';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import EmpresaPessoaApp from '../EmpresaPessoa/EmpresaPessoaApp';

class EmpresaFuncionarioApp extends XAPPComponent {

    render() {
        let { xappRouteParams, isLookup = false } = this.props;
        if (_.isUndefined(xappRouteParams) || _.isNull(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <EmpresaPessoaApp
                    xappRouteParams={xappRouteParams}
                    isGestor={true}
                    label="Funcionários"
                    target={isLookup ? "spvwempresapessoafuncionariolookup" : "spvwempresapessoafuncionario"}
                    {...this.props}
                    defaultTipo={[1]}
                />
            </React.Fragment>
        )
    };
}


export default EmpresaFuncionarioApp;
